// extracted by mini-css-extract-plugin
export default {"price":"U5-z","onSale":"V5-z","msrpLabelPrice":"W5-z","msrpLabel":"X5-z","originalPrice":"Y5-z","percentOff":"Z5-z"};